<div class="popup-overlay" *ngIf="isVisible" [class.closing]="isClosing" (click)="onOverlayClick($event)">
    <div class="popup-container" [class.closing]="isClosing">
        <div class="popup-header">
            <h3>{{ "Job Details" | translate }}</h3>
            <button class="close-btn" (click)="onClose()">
                <span>&times;</span>
            </button>
        </div>

        <div class="popup-body">
            <div class="row w-100 m-0">
                <div class="w-100 col-12 p-0">
                    <form [formGroup]="jobDetailsForm">
                        <div class="card-data">
                            <h4>
                                {{ "Job Details" | translate }}
                                <span class="optional-text">({{ "Optional" | translate }})</span>
                            </h4>

                            <div class="row mb-3">
                                <div class="col-12">
                                    <label>{{ "Target Job" | translate }}</label>
                                </div>
                                <div class="col-12">
                                    <input type="text" formControlName="jobTitle"
                                        placeholder="{{ 'e.g. Senior Software Engineer' | translate }}" />
                                </div>
                            </div>

                            <div class="row mb-3">
                                <div class="col-12">
                                    <label>{{ "Industry" | translate }}</label>
                                </div>
                                <div class="col-12">
                                    <input type="text" formControlName="company"
                                        placeholder="{{ 'e.g. Google, Microsoft' | translate }}" />
                                </div>
                            </div>

                            <div class="row mb-1">
                                <div class="col-12">
                                    <label>{{ "Objective" | translate }}</label>
                                </div>
                                <div class="col-12">
                                    <textarea formControlName="jobDescription" rows="6" cols="20"
                                        placeholder="{{ 'Paste the job description here to tailor your cover letter...' | translate }}"></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="next-container px-md-5 py-2 px-2 mobile-buttons">


                            <button type="button" class="gradient-button" (click)="onGenerateCoverLetter()"
                                [disabled]="loading">
                                <span *ngIf="!loading">{{ "Generate Cover Letter" | translate }}</span>
                                <span *ngIf="loading">{{ "Generating..." | translate }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>